var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327.487,
    height: 235.829,
    viewBox: "0 0 327.487 235.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(-51.257 -88.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(51.258 88.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M20.888,194.192C1.681,168.384-4.721,133.614,3.521,102.515,23.631,26.643,115.7,3.568,184.742,10.446c18.508,1.845,38.251,6.918,56.387,1.225,15.537-4.88,32.637-16.088,49.374-9.8,9.527,3.581,16.113,12.368,20.784,21.414,14.218,27.544,18.875,61.564,14.764,92.158-3.338,24.836-10.846,56.05-33.247,70.6-15.889,10.32-36.213,10.117-55.1,8.684-25.52-1.934-50.242-2.961-72.579,11.585-14.223,9.264-27.44,20.68-43.532,26.066-15.741,5.267-33.192,4.22-48.913-1.106-20.04-6.784-38.96-19.921-51.651-36.9l-.134-.179Z",
    transform: "translate(0)",
    fill: "#fdeff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1",
    transform: "translate(165.691 144.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M49.107,96.186a11.551,11.551,0,0,1-8.591-3.55c-4.14-4.28-8.4-8.444-12.607-12.646q-8.133-8.121-16.266-16.227c-2.913-2.913-5.8-5.849-8.708-8.77A9.437,9.437,0,0,1,0,47.917c.062-2.89,2.206-7.612,6.269-8.793,4.3-1.251,7.744-.171,10.8,2.928,2.68,2.726,5.476,5.344,8.179,8.055Q35.323,60.233,45.363,70.4c.59.6,1.2,1.181,1.81,1.74,1.01.924,1.406.9,2.408-.124,1.468-1.484,2.921-2.983,4.4-4.459q5.768-5.756,11.551-11.5Q71.7,49.9,77.871,43.722q13-13.015,25.991-26.03,7.469-7.48,14.953-14.945c2.991-3,6.641-3.262,10.4-2.167a8.226,8.226,0,0,1,5.2,4.987c1.888,4.4.629,8.117-2.532,11.325-6.618,6.727-13.306,13.392-19.979,20.072q-8.133,8.133-16.281,16.25T79.339,69.465Q69.249,79.532,59.143,89.6a63.971,63.971,0,0,1-5.189,4.762,7.978,7.978,0,0,1-4.863,1.818Z",
    transform: "translate(0)",
    fill: "#ff3838"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSuccess);
export default __webpack_public_path__ + "static/media/banner-success.6a19de3ca5b61218ea087705883190bf.svg";
export { ForwardRef as ReactComponent };